import { ENDPOINT } from "../../network/ENDPOINT";
import { callApiToServer } from '../callApi';

export async function listDailySettlementsAPI(authToken, payload) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authToken,
    };
    const body = JSON.stringify(payload);
    return await callApiToServer(body, header, "POST", ENDPOINT.settlement_daily);
  } catch (err) {
    throw err;
  }
}

export async function listMonthlySettlementsAPI(authToken, payload) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authToken,
    };
    const body = JSON.stringify(payload);
    return await callApiToServer(body, header, "POST", ENDPOINT.settlement_monthly);
  } catch (err) {
    throw err;
  }
}

export async function getSettlementDetailsAPI(authToken, settlementId) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authToken,
    };
    const endUrl = `${ENDPOINT.settlement_details}/${settlementId}`;
    return await callApiToServer(null, header, "GET", endUrl);
  } catch (err) {
    throw err;
  }
}

export async function recalculateSettlementAPI(authToken, payload) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authToken,
    };
    const body = JSON.stringify(payload);
    return await callApiToServer(body, header, "POST", ENDPOINT.settlement_recalculate);
  } catch (err) {
    throw err;
  }
}

export async function markSettledAPI(authToken, payload) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authToken,
    };
    const body = JSON.stringify(payload);
    return await callApiToServer(body, header, "POST", ENDPOINT.settlement_mark_settled);
  } catch (err) {
    throw err;
  }
}

export async function getCronStatusAPI(authToken) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authToken,
    };
    return await callApiToServer(null, header, "GET", ENDPOINT.settlement_cron_status);
  } catch (err) {
    throw err;
  }
}

export async function triggerDailyCronAPI(authToken, payload = {}) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authToken,
    };
    const body = JSON.stringify(payload);
    return await callApiToServer(body, header, "POST", ENDPOINT.settlement_run_daily_cron);
  } catch (err) {
    throw err;
  }
}
